/* @flow */
import Prefixer from "inline-style-prefixer";

// Flow doesn't actually use this; it's just here to make eslint-plugin-import
// shut up. The real StylesObject type is in prefixStyles.js.flow.
export type StylesObject = Object;

const prefixer = new Prefixer();

export default (style: StylesObject) => prefixer.prefix(style);

export const _prefixer = prefixer;



// WEBPACK FOOTER //
// ../nx-components/src/utils/prefixStyles.js